
import yearEndActivityCollect from "../pages/Subject/YearEndActivityCollect";
import PaintSubject1211 from "../pages/Subject/PaintSubject1211"
const subjectRouters = [
    {
        path: '/subject/yearEndActivityCollect',
        name: 'yearEndActivityCollect',
        component: yearEndActivityCollect
    }, {
        path: '/subject/PaintSubject1211',
        name: 'PaintSubject1211',
        component: PaintSubject1211

    }

]


export default subjectRouters;
